import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import css from "./DishComponent.module.css";
import {
  ButtonDelete,
  ModalForDelete,
  ImageReusable,
  ButtonEdit,
  ButtonDuplicate,
} from "../../../ui";
import { dishesService } from "../../../services/dishes-services";
import { dishesActions } from "../../../store/slices/dishes-slices";
import { DishUpdateModal } from "../dishesSectionModals";
import { DishDuplicateModal } from "../dishesSectionModals/DishDuplicateModal/DishDuplicateModal";

const DishComponent = ({ dish }) => {
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedDish, setSelectedDish] = useState(dish);
  const [isOpenDuplicateModal, setIsOpenDuplicateModal] = useState(false);
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  const { id, name, weight, weightNetto, price, cost, categories, img } = dish;
  const currentLanguage = i18n.language;

  const displayName = name[currentLanguage] || name["en"];
  const categoryName =
    categories
      .map((category) => category.name[currentLanguage] || category.name["en"])
      .join(", ") || t("unknown-category");

  const handleDeleteClick = async () => {
    try {
      await dishesService.deleteDishesById(id);
      dispatch(dishesActions.changeTrigger());
      toast.success(t("toast-dish-deleted"));
      setIsOpenDeleteModal(false);
    } catch (error) {
      console.error("Error deleting dish:", error);
      toast.error(t("toast-dish-delete-failed"));
    }
  };

  const handleRowClick = () => {
    setIsOpenUpdate(true);
  };

  const handleDeleteButtonClick = (e) => {
    e.stopPropagation(); // Prevent row click when delete button is clicked
    setIsOpenDeleteModal(true);
  };

  return (
    <section className={css.wrap} style={{ cursor: "pointer" }}>
      <div className={css.image}>
        <ImageReusable src={img} className={css.imageTag} alt="Food Image" />
      </div>

      <div className={css.name}>{displayName}</div>
      <div className={css.weight}>{weight}</div>
      <div className={css.weightNetto}>{weightNetto || 0}</div>
      <div className={css.price}>{price}</div>
      <div className={css.cost}>{cost}</div>
      <div className={css.category}>{categoryName}</div>

      <div className={css.actions}>
        <ButtonDelete onClick={handleDeleteButtonClick} isOnlyIcon={true} />
        <ButtonEdit onClick={handleRowClick} isOnlyIcon={true} />
        <ButtonDuplicate
          onClick={() => setIsOpenDuplicateModal(true)}
          isOnlyIcon={true}
        />
      </div>

      {isOpenUpdate &&
        createPortal(
          <DishUpdateModal
            dish={selectedDish}
            setIsOpenUpdate={setIsOpenUpdate}
          />,
          document.body
        )}

      {isOpenDeleteModal &&
        createPortal(
          <ModalForDelete
            handleDeleteClick={handleDeleteClick}
            setIsOpenDeleteModal={setIsOpenDeleteModal}
            name={t("dish")}
          />,
          document.body
        )}

      {isOpenDuplicateModal &&
        createPortal(
          <DishDuplicateModal
            setIsOpen={setIsOpenDuplicateModal}
            selectedDish={dish}
            setSelectedDish={setSelectedDish}
            setIsOpenUpdate={setIsOpenUpdate}
          />,
          document.body
        )}
    </section>
  );
};

export default React.memo(DishComponent);
